module.exports = __webpack_public_path__ + "static/media/ios-mic-off.18ecd755.svg";